import dayjs from "dayjs";
import { formatNumber } from "digiwash-core";
import { LogisticScheduledTask } from "../types/server";

export function scheduledDateTitle(task: LogisticScheduledTask) {
  let startDate = dayjs(`${task.period.date} ${task.period.start}`);
  let endDate = dayjs(`${task.period.date} ${task.period.end}`);

  let output = `${formatNumber(
    startDate.format("dddd، D MMMM YY")
  )} - ${formatNumber(startDate.format("HH:mm"))} تا ${formatNumber(
    endDate.format("HH:mm")
  )}`;

  return output;
}

function contentGenerator(type, task) {
  if (task) {
    let timeText = scheduledDateTitle(task);

    if (type === "collection") {
      return {
        title: "جمع‌آوری:",
        time: timeText,
        location: task.address.address_text,
        action: "تغییر آدرس و زمان جمع‌آوری",
      };
    }

    return {
      title: "تحویل:",
      time: timeText,
      location: task.address.address_text,
      action: "تغییر آدرس و زمان تحویل",
    };
  } else {
    if (type === "collection") {
      return {
        title: "جمع‌آوری:",
        time: "جمع آوری در تاریخ و ساعت...",
        location: "جمع آوری از محل...",
        action: "تعیین آدرس و زمان جمع‌آوری",
      };
    }

    return {
      title: "تحویل:",
      time: "تحویل در تاریخ و ساعت...",
      location: "تحویل در محل...",
      action: "تعیین آدرس و زمان تحویل",
    };
  }
}

export { contentGenerator };
